module.exports = __webpack_public_path__ + "assets/img/title-80905ad7.png";